import { useEffect, useState } from 'react'
import api from '../../../../../services/api'
import Form, { Input, Select } from '../../../../../components/Form'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../../../../hooks/toast'
import { useLoading } from '../../../../../hooks/loading'
import { useUpdateDataTable } from '../../../../../hooks/dataTable'
import { FinancialCategoryType, FormDataProtocol } from '../../domain/protocols'
import { apiCreate, apiUpdate } from '../../domain/api'
import { nameActions } from '../../domain/info'

type IsOpenInModalProps = {
  idParent: number
  parentType?: 'C' | 'D'
  handleOnClose: () => void
}

type TypesFormProps = {
  valueInput?: string
  isOpenInModal?: false | IsOpenInModalProps
  typeForm:
    | 'create'
    | {
        idUpdate: number
        inputValue: string
        idParentUpdate?: string
        type: string

        active: boolean
      }
}

export const FormCategory = ({
  isOpenInModal,
  typeForm
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { updateDataTable } = useUpdateDataTable()
  const [defaultValues, setDefaultValues] = useState<{
    name: string
    type: string
    active: number
  }>()

  const { activeLoading, disableLoading } = useLoading()

  useEffect(() => {
    if (typeForm !== 'create') {
      setDefaultValues({
        name: typeForm.inputValue,
        type: typeForm.type,
        active: typeForm.active ? 1 : 0
      })
    }
  }, [typeForm])

  const onSubmitForm = async (data: FormDataProtocol) => {
    try {
      if (typeForm === 'create') {
        if (isOpenInModal) {
          const { handleOnClose, idParent, parentType } = isOpenInModal
          const dataCreate: {
            name: string
            parent_id: number
            type: FinancialCategoryType
          } = {
            name: data.name,
            parent_id: idParent,
            type: parentType
          }
          activeLoading()
          try {
            await api.post(apiCreate(), dataCreate)
            handleOnClose()
            disableLoading()
            updateDataTable()
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar o registro',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            handleOnClose()
            disableLoading()
            updateDataTable()
          }
        } else {
          try {
            const dataCreate: { name: string; type: FinancialCategoryType } = {
              name: data.name,
              type: data.type
            }
            activeLoading()
            await api.post(apiCreate(), dataCreate)
            disableLoading()
            history.push(nameActions.read.to)
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar o registro',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            disableLoading()
            updateDataTable()
          }
        }
      } else {
        if (isOpenInModal) {
          const { handleOnClose, parentType } = isOpenInModal
          const id = typeForm.idUpdate
          const dataUpdate: { name: string; type: FinancialCategoryType } = {
            name: data.name,
            type: parentType
          }

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            handleOnClose()
            addToast({
              type: 'success',
              title: 'Registro atualizado',
              description: 'Registro alterado com sucesso'
            })
          } catch (error) {
            disableLoading()
            handleOnClose()
            addToast({
              type: 'error',
              title: 'Erro ao atualizar o registro',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        } else {
          const dataUpdate: { name: string; type: FinancialCategoryType } = {
            name: data.name,
            type: data.type
          }
          const id = typeForm.idUpdate

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            history.push(nameActions.read.to)
            addToast({
              type: 'success',
              title: 'Registro atualizado',
              description: 'Registro alterado com sucesso'
            })
          } catch (error) {
            history.push(nameActions.read.to)
            addToast({
              type: 'error',
              title: 'Erro ao atualizar o registro',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        }
      }
      disableLoading()
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
        if (isOpenInModal) isOpenInModal.handleOnClose()
      }
    }
  }

  return (
    <Form
      onSubmit={onSubmitForm}
      defaultValues={typeForm === 'create' ? {} : defaultValues}
    >
      <>
        <div className="row mb-5">
          <Input
            name="name"
            className={isOpenInModal ? '' : 'col-md-3'}
            label="Nome"
            rules={{ required: true }}
          />
          {!isOpenInModal && (
            <Select
              name="type"
              className="col-md-3"
              label="Tipo"
              options={[
                {
                  name: 'Crédito',
                  value: 'C'
                },
                {
                  name: 'Débito',
                  value: 'D'
                }
              ]}
              blank
              defaultValue=""
            />
          )}
          {!isOpenInModal && typeForm !== 'create' && (
            <Select
              name="active"
              className="col-md-3"
              label="Ativo"
              options={[
                {
                  name: 'Sim',
                  value: 1
                },
                {
                  name: 'Não',
                  value: 0
                }
              ]}
              blank
              defaultValue=""
            />
          )}
        </div>
        {isOpenInModal && typeForm !== 'create' && (
          <div className="row mb-5">
            <Select
              name="active"
              className="col-md-6"
              label="Ativo"
              options={[
                {
                  name: 'Sim',
                  value: 1
                },
                {
                  name: 'Não',
                  value: 0
                }
              ]}
              blank
              defaultValue=""
            />
          </div>
        )}
        <div className="card-footer d-flex justify-content-end py-6 px-9">
          <button type="submit" className="btn btn-primary">
            Salvar
          </button>
        </div>
      </>
    </Form>
  )
}
